var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{staticClass:"mobile-menu"},_vm._l((_vm.components),function(is){return _c(is,{key:is.is,tag:"component"})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }